import React from 'react';

export const StandardContentGrid = ({ children }) => {
    return <div className="grid grid-cols-1 lg:grid-cols-2-1 gap-10">{children}</div>;
};

export const StandardContentChildGrid = ({ children }) => {
    return <div className="grid grid-cols-1 gap-5">{children}</div>;
};
